import React, { Component } from "react";
import { Modal, Form, Input, Spin, Checkbox } from "antd";
import { inject, observer } from "mobx-react";
import { importPrivateSites } from "services/privatenetworks";
import co from "co";

const FormItem = Form.Item;
const TextArea = Input.TextArea;

@Form.create({})
@inject("rootStore")
@observer
class ImportPrivateSitesDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			importingPrivateSites: false
		};
	}
	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	importPrivateSites = () => {
		const {
			rootStore: { privateNetworkStore }
		} = this.props;

		const privateNetwork = privateNetworkStore.privateNetwork;

		this.props.form.validateFieldsAndScroll((err, vals) => {
			if (err) {
				return;
			}
			co(function*() {
				this.setState({
					importingPrivateSites: true
				})
				const response = yield importPrivateSites(privateNetwork.id, vals);
				if (response && response.errorList) {
					this.props.form.setFieldsValue({
						siteList: response.errorList
					})
				}				
				this.setState({
					importingPrivateSites: false
				})
			}.bind(this));			
		});
	};

	hideDialog = () => {
		const {
			rootStore: { privateNetworkStore }
		} = this.props;

		privateNetworkStore.hideImportPrivateSitesDialog();
	};

	render() {
		const {
			rootStore: { privateNetworkStore }
		} = this.props;

		const ui = privateNetworkStore.ui;

		const spinning = this.state.importingPrivateSites;

		return (
			<Modal
				visible={ui.importPrivateSitesDialogVisible}
				title="Add Private Network Accounts"
				okText="Import"
				cancelText="Close"
				onCancel={this.hideDialog}
				onOk={this.importPrivateSites}
				destroyOnClose={true}
			>
				<Spin spinning={spinning}>
					<Form>
						<FormItem style={{ marginBottom: 0 }}>
							{this.props.form.getFieldDecorator("selfHosted", {
								valuePropName: "checked",
								initialValue: false
							})(<Checkbox>Wordpress Blog (Self Hosted)</Checkbox>)}
						</FormItem>
						<FormItem label="Sites">
							{this.props.form.getFieldDecorator("siteList", {
								rules: [
									{
										required: true,
										message: "Please enter the list of sites"
									}
								]
							})(
								<TextArea
									rows={8}
									placeholder="site.com|email@domain.com|username|password"
								/>
							)}
						</FormItem>
					</Form>
				</Spin>
			</Modal>
		);
	}
}

export default ImportPrivateSitesDialog;
